import React, { Component } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import actions from "./redux/action";
import { requestLogout, requsetGetProfile, requsetGetSubscription } from "./api/apis";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import BasicModal from "../../components/basicModal/BasicModal";
import LoadingPage from "../../components/loading/Loading";
import { withTranslation } from "react-i18next";
import Cookies from "js-cookie";
import api_domain_config from "./constants/common";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      linkToPersonalCenter: false, //是否跳转到个人中心
      linkToLogin: false, //是否跳转到登录
      linkToPurchase: false, //是否跳转到购买链接
      //登出确认弹窗信息
      basicModalObj: {
        visible: false,
        content: this.props.t("loginAndSignUp:logoutWarnTips"),
        onCancel: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
        },
        onOk: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
          this.handleLogout();
        },
      },
      loadding: true, //当前是否正在载入
    };
  }

  componentDidMount() {
    if (Cookies.get("authorization")) {
      this.initUserInfo();
    } else {
      this.setState({ loadding: false });
      if (window.location.hash.match(/personal-center|\/purchase/)) {
        this.handleNavigationToLogin();
      }
    }
  }

  /**
   * 跳转到当前个人中心
   */
  handleNavigationToPersonalCenter = () => {
    this.setState(
      {
        linkToPersonalCenter: true,
      },
      () =>
        this.setState({
          linkToPersonalCenter: false,
        })
    );
  };

  /**
   * 跳转到登录
   */
  handleNavigationToLogin = () => {
    this.setState(
      {
        linkToLogin: true,
      },
      () =>
        this.setState({
          linkToLogin: false,
        })
    );
  };

  /**
   * 跳转到购买页面
   */
  handleNavigationToPurchase = () => {
    this.setState(
      {
        linkToPurchase: true,
      },
      () =>
        this.setState({
          linkToPurchase: false,
        })
    );
  };

  /**
   * 初始化用户信息
   */
  initUserInfo = () => {
    this.handleRequsetGetProfile();
    this.handleGetSubscription();
  };

  /**
   *请求获取用户信息
   */
  handleRequsetGetProfile = () => {
    requsetGetProfile()
      .then(res => {
        if (res.code === 200) {
          this.props.onProfileObjChange(res.data);
          if (!window.location.hash.match(/personal-center|\/purchase/)) {
            this.handleNavigationToPersonalCenter();
          }
        }
        // else if (res.code === 401) {
        //   //认证码过期
        //   // localStorage.removeItem("authorization");
        //   Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
        //   this.handleNavigationToLogin();
        // }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loadding: false });
      });
  };

  /**
   *  退出登录
   */
  handleLogout = () => {
    this.props.onProfileObjChange(null);
    this.props.onSubscriptionChange(null);
    Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
    // localStorage.removeItem("authorization");
    this.handleNavigationToLogin();
    requestLogout()
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *获取用户订阅信息
   */
  handleGetSubscription = () => {
    requsetGetSubscription()
      .then(res => {
        console.log(res);
        if (res.code === 200) {
          this.props.onSubscriptionChange(res.data.subscription);
          this.handleLoginRedirect(res.data.subscription && res.data.subscription.status === "Active");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *控制用户登录完毕登录后的跳转链接
   * @param {Boolean} isVIP 当前用户是不是VIP（非必填）
   */
  handleLoginRedirect = isVIP => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get("redirect");
    const to = urlParams.get("to");
    if (urlParams.has("redirect")) {
      if (redirect && to === "purchase" && !isVIP) {
        console.log("购买链接");
        this.handleNavigationToPurchase();
      } else if ((redirect && !to) || (redirect && to === "purchase" && isVIP)) {
        console.log("直接重定向到上一个链接");
        window.location.replace(redirect);
      }
    } else {
      console.log("跳转到某个链接");
      if (!window.location.hash.match(/personal-center|\/purchase/)) {
        this.handleNavigationToPersonalCenter();
      }
    }
  };

  render() {
    return (
      <>
        {this.state.linkToPersonalCenter && <Navigate to="./personal-center/profile" replace={true} />}
        {this.state.linkToLogin && <Navigate to="./login" replace={true} />}
        {this.state.linkToPurchase && <Navigate to={`/purchase${this.props.urlSearch}`} replace={true} />}

        <Header
          profileObj={this.props.profileObj}
          subscription={this.props.subscription}
          handleLogout={() => {
            const basicModalObj = { ...this.state.basicModalObj };
            basicModalObj.visible = true;
            this.setState({
              basicModalObj,
            });
          }}
        />
        {this.state.loadding ? <LoadingPage /> : <Outlet />}
        <Footer />
        <BasicModal {...this.state.basicModalObj} />
      </>
    );
  }
}

const mapStateToPropos = state => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: subscription => dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["common", "loginAndSignUp"])(App));
